export const _bullet = /(?:[*+-]|R?\d{1,9}[.)]|\(R?\d{1,9}\)|\[R?\d{1,9}\])/
